/**
 * 稽核時間戳記的顯示（data-model 2.2）。
 *
 * `createdAt` 與 `updatedAt` 存的是 UTC，畫面一律換成使用者的本地時間再顯示：
 * 使用者要對照的是自己牆上的鐘，不是 Z 結尾的字串。
 */

function pad2(value: number): string {
  return value.toString().padStart(2, '0');
}

function parse(value: string | null | undefined): Date | null {
  if (!value) return null;
  const at = new Date(value);
  return Number.isNaN(at.getTime()) ? null : at;
}

/** 2026/08/24 21:30 */
export function formatStamp(value: string | null | undefined): string | null {
  const at = parse(value);
  if (!at) return null;
  return (
    `${at.getFullYear()}/${pad2(at.getMonth() + 1)}/${pad2(at.getDate())} ` +
    `${pad2(at.getHours())}:${pad2(at.getMinutes())}`
  );
}

/**
 * 卡片上的短版：同一年只寫 08/24 21:30，跨年才補上年份。
 * 卡片空間有限，年份對今年的資料是純粹的雜訊。
 */
export function formatShortStamp(
  value: string | null | undefined,
  now: Date = new Date(),
): string | null {
  const at = parse(value);
  if (!at) return null;

  const sameYear = at.getFullYear() === now.getFullYear();
  const day = `${pad2(at.getMonth() + 1)}/${pad2(at.getDate())}`;
  const clock = `${pad2(at.getHours())}:${pad2(at.getMinutes())}`;
  return sameYear ? `${day} ${clock}` : `${at.getFullYear()}/${day}`;
}
